import { Component, OnDestroy, OnInit } from '@angular/core';
import { ViewportScroller } from '@angular/common';
import { ActivatedRoute } from '@angular/router';
import { Subscription } from 'rxjs';
import { HelperService } from 'src/app/shared/helpers/helper.service';
import { COMPANY_PHONE_NUMBER } from 'src/app/constants/app.constants';

@Component({
  selector: 'app-terms-and-conditions',
  templateUrl: './terms-and-conditions.component.html',
  styleUrls: ['./terms-and-conditions.component.scss']
})
export class TermsAndConditionsComponent implements OnInit, OnDestroy {

  public COMPANY_PHONE_NUMBER = COMPANY_PHONE_NUMBER;

  private _subs: Subscription[] = [];

  constructor(
    public helperService: HelperService,
    private _activatedRoute: ActivatedRoute,
    private _viewportScroller: ViewportScroller) {}

  ngOnInit(): void {
    this._subs.push(
      this._activatedRoute.queryParams
        .subscribe(params => {
          if (params && params.scrollToSection) {
            this._viewportScroller.scrollToAnchor(params.scrollToSection);
          }
        }
      )
    );
  }

  ngOnDestroy(): void {
      this._subs.forEach(s => s.unsubscribe());
  }

}
